import { create } from "zustand";

type DatasetIdentifiersState = {
  ids: Set<string>;
  addIdentifier: (id: string) => void;
  removeIdentifier: (id: string) => void;
  clear: () => void;
};

const useDatasetIdentifiersStore = create<DatasetIdentifiersState>((set, get) => ({
  ids: new Set<string>(),
  addIdentifier: (id: string) => {
    get().ids.add(id);
    set({ ids: get().ids });
  },
  removeIdentifier: (id: string) => {
    get().ids.delete(id);
    set({ ids: get().ids });
  },
  clear: () => {
    get().ids.clear();
    set({ ids: get().ids });
  },
}));

export default useDatasetIdentifiersStore;
